
import { defineComponent, reactive, ref } from 'vue'
import NavMenu from '@/compontents/nav-menu/index'
import NavHeader from '@/compontents/nav-header/index'
export default defineComponent({
  setup() {
    //定义菜单展开宽度
    const asideWidth = ref('200px')
    const isAsideWidth = ref(false)
    /* 获取NavHeader参数，设置菜单宽度大小*/
    const handleIconChange = (isIcon: boolean) => {
      isAsideWidth.value = isIcon
      asideWidth.value = isIcon ? '60px' : '200px'
    }

    return {
      asideWidth,
      isAsideWidth,
      handleIconChange
    }
  },
  components: {
    NavMenu,
    NavHeader
  }
})
